var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIncident(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h64v64H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M31.781 8h.012c.995 0 1.92.493 2.477 1.307l.106.168 24.207 41a2.999 2.999 0 0 1-2.382 4.518L56 55H8a3 3 0 0 1-2.695-4.318l.1-.188 23.793-41a3.001 3.001 0 0 1 2.385-1.487L31.78 8h.012zm.035 8.938L13.21 49h37.535l-18.93-32.062zm.169 24.078c1.486 0 2.336.879 2.336 2.487 0 1.365-.79 2.427-2.306 2.427-1.486 0-2.336-.849-2.336-2.427 0-1.395.788-2.487 2.306-2.487zm2.2-15.725l-.35 9.732v4.881L30.133 40V25.643l4.052-.352z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncident);
export default __webpack_public_path__ + "static/media/incident.7d1789b828094f165b73c9f8a9400c19.svg";
export { ForwardRef as ReactComponent };